"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../../util");

var primary = function primary(theme) {
  return /*#__PURE__*/(0, _react.css)("&+label{color:", theme.color.radioButtons.primary.itemColor, ";height:100%;border-radius:50rem;line-height:inherit;letter-spacing:0;transition:color 0.3s,background-color 0.3s;min-width:", (0, _util.rem)(87), ";&:hover{color:", theme.color.radioButtons.primary.itemColorHover, ";}}&:checked+label{color:", theme.color.radioButtons.primary.itemColorActive, ";background-color:", theme.color.radioButtons.primary.itemBackgroundActive, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:primary;"));
};

var secondary = function secondary(theme) {
  return /*#__PURE__*/(0, _react.css)(primary(theme), ";&+label{color:", theme.color.radioButtons.secondary.itemColor, ";&:hover{color:", theme.color.radioButtons.secondary.itemColorHover, ";}}&:checked+label{color:", theme.color.radioButtons.secondary.itemColorActive, ";background-color:", theme.color.radioButtons.secondary.itemBackgroundActive, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:secondary;"));
};

var styles = {
  primary: primary,
  secondary: secondary
};
exports.styles = styles;
//# sourceMappingURL=RadioButton.styles.js.map